import { useLocation } from "react-router-dom";
import DesktopNav from "./headerDesktop.component";
import MobileNav from "./headerMobile.component";

const Header = () => {
  const pathname = useLocation();

  return (
    <header className="w-full fixed top-0 left-0 z-50 shadow-2xl backdrop-blur-lg bg-gradient-to-r">
      <div className="hidden lg:block">
        <DesktopNav pathname={pathname} />
      </div>
      <div className="lg:hidden">
        <MobileNav pathname={pathname} />
      </div>
    </header>
  );
};

export default Header;
